import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getProvince = async () => {
  return await get<ApiResponse<any[]>>("/province").then((res) => res);
};